module.exports = __webpack_public_path__ + "img/bj32.684cdf11.png";